import { inject, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

import { CsvAsStringArrays } from '@malou-io/package-utils';

import { ReviewsRating } from '#modules/reviews/models/reviews.interface';
import { AbstractCsvService } from '#modules/statistics/components/download-insights-modal/models/csv-service.abstract';
import { StatisticsStore } from '#modules/statistics/stores/store/statistics.store';
import { EnumTranslatePipe } from '#shared/pipes/enum-translate.pipe';

type Data = ReviewsRating[];

@Injectable()
export class ReviewsRatingsTotalCsvInsightsService extends AbstractCsvService<Data> {
    private readonly _enumTranslatePipe = inject(EnumTranslatePipe);
    private readonly _statisticsStore = inject(StatisticsStore);

    protected override _isDataValid(data: Data): boolean {
        return !!data.length;
    }

    protected override _getData$(): Observable<Data> {
        return of(this._statisticsStore.reviewsRatingsTotalData());
    }

    protected override _getCsvDataRows(data: Data): CsvAsStringArrays {
        return data
            .map((d) => {
                const rating = d.rating?.toString() ?? '-';
                return d.platforms.map((platform) => {
                    const platformKeyTranslated = this._enumTranslatePipe.transform(platform.key, 'platform_key');
                    const reviewCount = platform.nbReviews.toString();
                    return [platformKeyTranslated, reviewCount, rating];
                });
            })
            .flat();
    }

    protected override _getCsvHeaderRow(): CsvAsStringArrays[0] {
        return ['Platform', 'Review count', 'Rating'];
    }
}
